import React, { useState } from 'react';
import { Calendar } from 'lucide-react';
import BookingModal from './BookingModal';

const StickyBookingButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="fixed bottom-6 right-6 z-40">
        <button
          onClick={() => setIsModalOpen(true)}
          className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-full shadow-lg flex items-center space-x-2 transition-all duration-200 hover:scale-105"
        >
          <Calendar className="h-5 w-5" />
          <span className="font-semibold">Book a Test</span>
        </button>
      </div>
      
      <BookingModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        service="Professional Radon Testing"
      />
    </>
  );
};

export default StickyBookingButton;